import PuxPageDetails from "../../../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import SmartTable from "../../../../../global/components/table/table.vue";

import getTableApi from "../../../../../const/TableApis";

const TABLE_ID = "BerichtKuraQM";

// @vue/component
export default {
  name: "BerichtKuraQM",
  components: {
    SmartTable,
    PuxPageDetails,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }) + "?tab_id=" + this.report.pk,
        rowActions: [
          {
            label: "_LBL_BERICHT_KURA_Q_M_ROW_ACTIONS_ANTRAEGE_",
            route: "root.foerderantrag",
            routeParameters: [{ rowPathObject: "antragfilter" }],
          },
        ],
        label: this.report.tab_kbez,
        sortable: true,
        pagination: true,
        details: false,
        showHeader: false,
        view: {
          filter: "top",
        },
      },
    };
  },
};
